import { Component, inject, OnInit, ViewEncapsulation, OnDestroy } from '@angular/core';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { CommonModule } from '@angular/common';
import { PSIC_COMPONENTS } from '@pacificspecialtyinsurancecompany/psic-ng-components';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbarModule } from '@angular/material/toolbar';
import { Router, ActivatedRoute, RouterModule } from '@angular/router';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Observable, Subscription, combineLatest } from 'rxjs';
import { map, shareReplay, filter } from 'rxjs/operators';
import { DesktopListViewComponent } from '../desktop-list-view/desktop-list-view.component';
import { PolicySnapshotService } from 'src/app/services/data-service/policy-snapshot.service';
import { PolicyDetailsService } from '../services/policy-details.service';
import { Store } from '@ngrx/store';
import { PolicyState } from '../store/policy/policy.reducer';
import { selectSelectedSection } from '../store/selection/selection.selector';

@Component({
    selector: 'app-policy-snapshot-view',
    templateUrl: './policy-snapshot-view.component.html',
    styleUrls: ['./policy-snapshot-view.component.scss'],
    imports: [
        CommonModule,
        MatIconModule,
        MatInputModule,
        MatListModule,
        MatSidenavModule,
        MatToolbarModule,
        RouterModule,
        DialogModule,
        ButtonModule,
        ...PSIC_COMPONENTS,
        DesktopListViewComponent,
    ],
})
export class PolicySnapshotView implements OnInit, OnDestroy {
    isHandset$!: Observable<boolean>;
    fields: any[] = [];
    private combinedSubscription: Subscription;
    public policyDetails = inject(PolicyDetailsService);
    public policyDetailResponse: any;
    isThirdParty = false;

    constructor(
        private breakpointObserver: BreakpointObserver,
        private policySnapshot: PolicySnapshotService,
        private store: Store<{ policy: PolicyState }>,
        private router: Router,
        private route: ActivatedRoute
    ) {
        this.isHandset$ = this.breakpointObserver.observe(Breakpoints.Handset).pipe(
            map((result) => result.matches),
            shareReplay()
        );
    }
    selectedSection$ = this.store.select(selectSelectedSection);
    ngOnInit(): void {
        this.isThirdParty = this.router.url.includes('third-party');
        this.combinedSubscription = combineLatest([
            this.store.select((state) => state.policy.data).pipe(filter((data) => !!data)),
        ]).subscribe(([policyData]) => {
            let policyNumber = Object.keys(policyData)[0];
            const mapped = this.policySnapshot.mapApiToFieldsJson(policyData, policyNumber!);
            if (mapped && mapped.length) {
                this.fields = mapped;
            } else {
                console.warn('No mapped fields for policy:', policyNumber);
                this.fields = [];
            }
        });
    }

    ngOnDestroy(): void {
        if (this.combinedSubscription) {
            this.combinedSubscription.unsubscribe();
        }
    }
}
